import React from 'react';
import PropTypes from 'prop-types';
import Card from '@pattern-library/card';
import { HandshakeIcon } from '@pattern-library/icon';
import classNames from 'classnames';
import { sendAnalyticsEvent } from '../../utils/analytics';

const propTypes = {
    planName: PropTypes.string,
    planId: PropTypes.string,
    maEnrollmentCount: PropTypes.number,
    maPlanCount: PropTypes.number,
    arkManagedAcctProductCode: PropTypes.string,
    content: PropTypes.object.isRequired
};

function ManagedAccountBannerBody({ content, planName, planId, maEnrollmentCount, maPlanCount, arkManagedAcctProductCode }) {
    if(maPlanCount === 0) { 
        return (<></>);
    }

    const cardClassNames = classNames('managed-account-banner', {'managed-account-banner_enrolled' : maEnrollmentCount > 0, 'managed-account-banner_unenrolled': maEnrollmentCount === 0});
    const bannerLabelsClassName="mananaged-account-banner-labels"
    const bannerTitleMarkup = <h2 className="asc-lead-line--large">{content.title}</h2>;
    const planNameMarkup = <p className="asc-mb-0 asc-p--footnote" dangerouslySetInnerHTML={{ __html: planName }} />;
    
    let labelsContent;
    let buttonClass;
    let bannerContent;
    
    if(maEnrollmentCount > 0) {
        buttonClass = 'asc-btn asc-btn--tertiary';

        if (maEnrollmentCount === 1 && maPlanCount === 1) {
            bannerContent = content.enrolled.onePlan;
            labelsContent = (
                <div className={bannerLabelsClassName}>
                    {bannerTitleMarkup}
                    {planNameMarkup}
                </div>
            );
        } else {
            labelsContent = (
                <div className={bannerLabelsClassName}>
                    {bannerTitleMarkup}
                </div>
            );
            if (maEnrollmentCount === maPlanCount) {
                bannerContent = content.enrolled.allPlans;
            } else {
                bannerContent = content.enrolled.somePlans;
            }
        }
    } else {
        bannerContent = content.notEnrolled;
        buttonClass = 'asc-btn asc-btn--pill';
        if(maPlanCount === 1) {
            labelsContent = (
                <div className={bannerLabelsClassName}>
                    {planNameMarkup}
                </div>
            );
        }
    }

    const handleClick = () => {
        sendAnalyticsEvent(`MA ${maPlanCount > 0 ? 'E' : 'U'} Dashboard ${arkManagedAcctProductCode}`);
    };

    return (
        <Card
            border
            padding={false}
            className={cardClassNames}
        >
            <HandshakeIcon color="gray-80" size="xl" />
            {labelsContent && labelsContent}
            <div className="managed-account-banner-content">
                <p className="asc-mb-0 asc-p--small">{bannerContent.bodyText}</p>
            </div>
            <a className={buttonClass} href={`/participant/managedaccount/Plan?p=p${planId}`} onClick={handleClick}>
                {bannerContent.buttonLabel}
            </a>
        </Card>
    );
}

ManagedAccountBannerBody.propTypes = propTypes;
export default ManagedAccountBannerBody;
